import React from "react";
import styled from "styled-components";

import FooterSectionBackgroundImg from "../../images/background6.jpg"
import { Marginer } from "../../Components/marginer"


const FooterSectionContainer = styled.div`
	width: 100%;
	height: 400px;
	background: url(${FooterSectionBackgroundImg});
	background-size: cover;
`;

const FooterSectionInnerContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;
`;

const Contributor = styled.h3`
	margin: 0;
	line-height: 1.4;
	color: #000;
	font-weight: 700;
	font-size: 40px;
`;

const ContributorNames = styled.h5`
	margin: 0;
	color: #000;
	font-weight: 500;
	font-size: 20px;
`;

export function FooterSection(props){
	return <FooterSectionContainer>
	<FooterSectionInnerContainer>
	<Contributor>
		Contributors
	</Contributor>
	<ContributorNames>
		Jeet Shah
		<Marginer direction="vertical" margin={15} />
		Aakash Parmar
	</ContributorNames>
	</FooterSectionInnerContainer>
	</FooterSectionContainer>
}